

import moment from 'moment';
import trendingBlogQuery from '@/apollo/queries/blog/trendingBlogs'
import trendingBlogsOverideQuery from '@/apollo/queries/blog/trendingBlogsOveride'

export default {
  name: 'BlogTrendingSection',
  props: {
      tagFilters:{
        type: Array,
        default: ()=> [],
      },
      authorFilters:{
        type: Array,
        default: ()=> [],
      }
    },
  data() {
    return {
      strapiData: [],
      trendingBlogs: Object,
      trendingBlogsOveride: [],
    }
  },
  computed: {
    showTrendingBlogs() {
        let blogs = [];
        for(const item of this.trendingBlogsOveride) {
          for (const trendingBlog of item.trending_blogs) {
            blogs.push(trendingBlog);
          }
        }
        if (blogs.length >= 1) {
          return blogs;
        }
        return this.trendingBlogs;
    }
  },
  methods: {
  },
    apollo: {
      trendingBlogs: {
          prefetch: true,
          query: trendingBlogQuery,
          variables() {
            const returnObj = {};
            returnObj.currentlocale = this.$normalizeLocale(this.$i18n.locale);
            returnObj.today = moment().format('YYYY-MM-DD');
            if(this.tagFilters.length > 0)
            {
              returnObj.cats = this.tagFilters;
            }
            if(this.authorFilters.length > 0)
            {
              returnObj.authors = this.authorFilters;
            }

            return returnObj;
          },
          update(data) {
              return this.$normalizeStrapi(data?.blogs?.data);
          },
      },
      trendingBlogsOveride : {
        prefetch: true,
        query: trendingBlogsOverideQuery,
        variables() {
          const returnObj = {};
          returnObj.currentlocale = this.$normalizeLocale(this.$i18n.locale);
          
          if (this.tagFilters.length == 1) {
            returnObj.cat = this.tagFilters[0];
          } else {
            returnObj.cat = [];
          }

          return returnObj;
        },
        update(data) {
          return this.$normalizeStrapi(data?.blogCategories?.data);
        }
      }
    }
}
